import { countries, type Country } from './countries';
import { dailyIndex, todayKey } from './game';
import { getModeState } from './storage';

export const MODES = ['classic', 'flag', 'outline', 'connections', 'draw', 'trivia'] as const;
export type Mode = (typeof MODES)[number];

// Outline / Draw 都只从有轮廓几何的国家出题(Draw 需要真实形状比对)
const OUTLINE_POOL = countries.filter((c) => c.hasOutline);

export function poolFor(mode: string): Country[] {
  return mode === 'outline' || mode === 'draw' ? OUTLINE_POOL : countries;
}

/** 任意模式、任意 UTC 日的确定性答案(纯前端可算) */
export function answerFor(mode: string, day: string): Country {
  const pool = poolFor(mode);
  return pool[dailyIndex(mode, pool.length, day)];
}

/** 今日已通关的模式列表(读 localStorage) */
export function solvedModesToday(day: string = todayKey()): Mode[] {
  return MODES.filter((m) => getModeState(m, day).status === 'won');
}
